import React from 'react';
import * as S from './BoardingDropingBox.styles';
import CustomRadioButton from '../../../../../../stories/core-components/RadioButton/RadioButton';
import LocationBox from '../LocationPoints/LocationPoints';


const BoardingDropingBox = (props) =>{ 
    const {data,onClick,selectedItem} = props;
    return(
    <S.WrapperBox>
        {data.map((item)=> <LocationBox isSelection={true} key={item.add+item.id} time={item.viewTime} location={item.loc} address={item.add} isActive={(selectedItem  && item.id === selectedItem.id)} onClick={(evt)=>{
            evt.preventDefault();
        onClick(item)}}/>
       
        )}
    </S.WrapperBox>
);}
export default BoardingDropingBox;
